import { useEffect, useState } from "react";

export const LoginSlideshow = ({ slides = [], fit = "cover", interval = 4000, captionPos = "bottom", children }) => {
  const [idx, setIdx] = useState(0);
  const n = slides.length;
  useEffect(() => {
    if (n < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % n), interval);
    return () => clearInterval(t);
  }, [n, interval]);

  const fitClass = fit === "contain" ? "object-contain" : fit === "fill" ? "object-fill" : "object-cover";
  const prev = (idx - 1 + n) % n;
  const active = slides[idx] || {};
  const hasCaption = Boolean(active.title || active.caption);

  return (
    <div className="absolute inset-0" data-testid="login-slideshow">
      {slides.map((s, i) => {
        const layer = i === idx ? "z-[2] opacity-100" : i === prev && n > 1 ? "z-[1] opacity-100" : "z-0 opacity-0";
        const kb = i === idx && n > 1 ? (i % 2 === 0 ? "kenburns-a" : "kenburns-b") : "";
        return (
          <img
            key={s.url}
            src={s.url}
            alt={s.title || ""}
            className={`absolute inset-0 w-full h-full ${fitClass} will-change-[opacity,transform] transition-opacity duration-[1400ms] ease-in-out ${layer} ${kb}`}
          />
        );
      })}
      {children && <div className="absolute inset-0 z-[5] pointer-events-none">{children}</div>}
      {hasCaption && (
        <div key={idx} className={`absolute left-8 z-10 max-w-sm fade-up ${captionPos === "top" ? "top-8" : "bottom-14"}`} data-testid="slide-caption">
          <div className="rounded-xl bg-black/40 backdrop-blur-md border border-white/10 px-4 py-3">
            {active.title && <div className="text-white font-semibold text-sm tracking-wide" data-testid="slide-caption-title">{active.title}</div>}
            {active.caption && <div className="text-white/75 text-xs mt-0.5 leading-relaxed" data-testid="slide-caption-text">{active.caption}</div>}
          </div>
        </div>
      )}
      {n > 1 && (
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10" data-testid="slideshow-dots">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              aria-label={`Slide ${i + 1}`}
              data-testid={`slideshow-dot-${i}`}
              className={`rounded-full ring-1 ring-black/10 shadow-sm transition-all duration-300 ${i === idx ? "w-6 h-1.5 bg-white" : "w-1.5 h-1.5 bg-white/70 hover:bg-white"}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};
